import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import ButtonBase from 'material-ui/ButtonBase';
import Tooltip from 'material-ui/Tooltip';
import { TableRow, TableCell } from 'material-ui/Table';
import EditIcon from 'material-ui-icons/Edit';

import { mhzToLabel, inchToString } from '../../../../../lib/unitConversions';
import SimulationModelImg from '../SimulationModelImg';

import { impedanceModelingPropType } from '../propTypes';
import { OHM_DECIMALS, PSIN_DECIMALS } from '../../../../../constants/globals';

const styles = () => ({
  center:  {
    textAlign: 'center'
  },
  link: {
    color: 'inherit'
  },
  button: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      borderRadius: 5,
    },
    padding: 5,
  },
  image: {
    width: 125
  }
  
})

export const ImpedanceModelingRow = (props) => {
  const {
    impedanceModeling,
    classes,
    onSimulationModelClick,
    currentPath,
    lengthUnit,
    print
  } = props;
  const {
    copperKey,
    name,
    signal,
    simulationModel,
    // thickness,
    transmissionWidth,
    transmissionSpacing,
    selectedImpedance ,
  } = impedanceModeling;

  const transmissionSpacingDisplay = (signal && transmissionSpacing)
    ? inchToString(transmissionSpacing, lengthUnit, false)
    : '-';
  const transmissionWidthDisplay = ( signal && transmissionWidth)
    ? inchToString(transmissionWidth, lengthUnit, false)
    : '-';
  const rowClass = signal ? '' : classes.center;
  
  const editUrl= `/app/layers/${copperKey}/edit`;
  return (
    <TableRow
      hover
      selected={signal}
      key={copperKey}
    >
      <TableCell>
        <Link to={{ pathname: editUrl, state: { from: currentPath }}}>
          <Checkbox
            color="primary"
            checked={signal ? true : false}
            disableRipple
          />
        </Link>
      </TableCell>
      <TableCell>
        {name}
      </TableCell>
      <TableCell numeric={signal} className={rowClass}>
        {transmissionWidthDisplay}
      </TableCell>
      <TableCell numeric={signal} className={rowClass}>
        {transmissionSpacingDisplay}
      </TableCell>
      <TableCell className={rowClass}>
        {signal ? (
          <Tooltip title={simulationModel}>
            <ButtonBase
              focusRipple
              onClick={onSimulationModelClick}
            >
              <span className={classes.button}>
                <SimulationModelImg simulationModel={simulationModel} className={classes.image} />
              </span>
            </ButtonBase>
          </Tooltip>
        ) : '-'}
      </TableCell>
      <TableCell numeric={signal} className={classes.center}>
        {selectedImpedance
          ? (
            <Tooltip title={`Characteristic Impedance @ ${mhzToLabel(selectedImpedance.mhz)}`}>
              <div>
                {typeof selectedImpedance.characteristicImpedance === 'number'
                  ? selectedImpedance.characteristicImpedance.toFixed(OHM_DECIMALS)
                  : '-'}
              </div>
            </Tooltip>
          )
          : '-'}
      </TableCell>
      <TableCell className={rowClass}>
        {selectedImpedance
          ? (
            <Tooltip title={`Differential Impedance @ ${mhzToLabel(selectedImpedance.mhz)}`}>
              <div>
                {typeof selectedImpedance.differentialImpedance === 'number'
                  ? selectedImpedance.differentialImpedance.toFixed(OHM_DECIMALS)
                  : '-'}
              </div>
            </Tooltip>
          )
          : '-'}
      </TableCell>
      <TableCell className={rowClass}>
        {selectedImpedance
          ? (
            <Tooltip title={`Propagation Delay @ ${mhzToLabel(selectedImpedance.mhz)}`}>
              <div>
                {typeof selectedImpedance.propagationalDelay === 'number'
                  ? selectedImpedance.propagationalDelay.toFixed(PSIN_DECIMALS)
                  : '-'}
              </div>
            </Tooltip>
          )
          : '-'}
      </TableCell>
      {!print && (
        <TableCell>
          <IconButton title={`Edit ${name}`}>
            <Link to={{ pathname: editUrl, state: { from: currentPath }}} className={classes.link}>
              <EditIcon />
            </Link>
          </IconButton>
        </TableCell>
      )}
    </TableRow>
  );
}

ImpedanceModelingRow.propTypes = {
  classes:                PropTypes.objectOf(PropTypes.string).isRequired,
  onSimulationModelClick: PropTypes.func.isRequired,
  impedanceModeling:      impedanceModelingPropType.isRequired,
  currentPath:            PropTypes.string,
  lengthUnit:             PropTypes.string.isRequired,
  print:                  PropTypes.bool,
}

ImpedanceModelingRow.defaultProps = {
  currentPath: undefined,
  print: undefined,
}

export default withStyles(styles)(ImpedanceModelingRow);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/ImpedanceModelingsTable/ImpedanceModelingRow.jsx